<template>
  <div class="history-container">
    <ParticipantActivityResponseHistoryList :participantInfo="participantInfo" :surveyId="surveyId" :historylist="historylist" @view="onview" v-if="!isDisplayDetailView" />
    <ParticipantActivityResponseHistoryView @back="onback" :selectedLanguageCulture="selectedLanguageCulture" :historyDetails="historyDetails" :surveyData="surveyData" :questionDetails="questionDetails" :questionDetailsObj="questionDetailsObj" v-if="isDisplayDetailView && historyDetails" :selectedHistoryItem="selectedHistoryItem" />
  </div>
</template>

<script>
import ParticipantActivityResponseHistoryList from "@/components/participants/activity-response/participant-activity-response-history-list";
import ParticipantActivityResponseHistoryView from "@/components/participants/activity-response/participant-activity-response-history-view";
import _ from "lodash";

export default {
  name: "participant-activity-response-history",
  components: {
    ParticipantActivityResponseHistoryList,
    ParticipantActivityResponseHistoryView
  },
  data() {
    return {
      isDisplayDetailView: false,
      historyDetails: null,
      selectedHistoryItem: null
    };
  },
  props: {
    participantResponses: Array,
    historylist: {
      type: Array,
      default: null
    },
    surveyId: {
      type: String
    },
    surveyData: Object,
    selectedLanguageCulture: { type: String },
    questionDetails: {},
    participantInfo: {}
  },

  computed: {
    questionDetailsObj() {
      if (!this.questionDetails) {
        return null;
      }

      const questionDetailsObj = {};
      this.questionDetails.forEach(question => {
        questionDetailsObj[question.id] = question;
      });

      return questionDetailsObj;
    }
  },

  methods: {
    onview(item) {
      this.getHistoryView(item.id);
      this.selectedHistoryItem = item;
    },
    onback() {
      this.isDisplayDetailView = false;
      this.$emit("displayQuery");
    },
    getHistoryView(revisionId) {
      this.$api.getStudyResponseHistoryDetail(this.surveyId, revisionId).then(response => {
        const historyDetails = response.data && response.data.data;
        this.historyDetails = _.sortBy(historyDetails, "sequence");
        this.$emit("hideQuery");
        this.isDisplayDetailView = true;
      });
    }
  }
};
</script>
